var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** Draft order payment terms: resolve from API for edit/display. Used by Edit Draft Order and Duplicate (Payment Pending / Paid). */
import { PaymentTermType } from "../Constant";
import { normalizePaymentTermType, parseDueInDaysFromApi } from "../SharedFunctions";
/** Parse value to Date or null. Uses date part as local for ISO strings to avoid timezone shift. */
function parseDateSafe(value) {
    try {
        if (value == null)
            return null;
        if (value instanceof Date)
            return isNaN(value.getTime()) ? null : value;
        var s = String(value).trim();
        var dateOnly = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
        if (dateOnly) {
            var y = parseInt(dateOnly[1], 10);
            var m = parseInt(dateOnly[2], 10) - 1;
            var d_1 = parseInt(dateOnly[3], 10);
            var local = new Date(y, m, d_1);
            return isNaN(local.getTime()) ? null : local;
        }
        var d = new Date(value);
        return isNaN(d.getTime()) ? null : d;
    }
    catch (_a) {
        return null;
    }
}
/** Match template by term type and net days. */
function findTemplateByPaymentType(templates, paymentTermType, dueInDays) {
    var _a;
    try {
        if (paymentTermType == null || !templates.length)
            return undefined;
        var getType_1 = function (t) { var _a; return (_a = normalizePaymentTermType(t.paymentTermsType)) !== null && _a !== void 0 ? _a : ""; };
        var typeNorm_1 = (_a = normalizePaymentTermType(paymentTermType)) !== null && _a !== void 0 ? _a : "";
        return templates.find(function (t) {
            var typeUp = getType_1(t);
            if (typeNorm_1 === PaymentTermType.NET && typeUp === PaymentTermType.NET) {
                return t.dueInDays != null && dueInDays != null && Number(t.dueInDays) === Number(dueInDays);
            }
            if (typeNorm_1 === PaymentTermType.FIXED && typeUp === PaymentTermType.FIXED)
                return true;
            if (typeNorm_1 === PaymentTermType.RECEIPT && typeUp === PaymentTermType.RECEIPT)
                return true;
            if (typeNorm_1 === PaymentTermType.FULFILLMENT && typeUp === PaymentTermType.FULFILLMENT)
                return true;
            return false;
        });
    }
    catch (_b) {
        return undefined;
    }
}
/** Map draft order paymentTerms (API shape: PaymentTermsFromApi / ChiefSS PaymentTerms) to resolved terms. Used for Duplicate Payment Pending and Paid Orders. */
function getPaymentTermsDataOfDraftOrder(paymentTerms, templates) {
    var _a, _b, _c, _d, _e, _f, _g;
    try {
        if (paymentTerms == null)
            return null;
        var paymentTermType = normalizePaymentTermType((_b = (_a = paymentTerms.paymentTermsType) !== null && _a !== void 0 ? _a : paymentTerms.paymentTermType) !== null && _b !== void 0 ? _b : null);
        var dueInDays = parseDueInDaysFromApi(paymentTerms.dueInDays);
        var issueDate = parseDateSafe(paymentTerms.issueDate);
        var dueDate = parseDateSafe(paymentTerms.dueDate);
        var customDueDate = parseDateSafe(paymentTerms.customDueDate);
        var rawId = (_c = paymentTerms.id) !== null && _c !== void 0 ? _c : paymentTerms.Id;
        var paymentTermsTemplateId = (_d = paymentTerms.paymentTermsTemplateId) !== null && _d !== void 0 ? _d : null;
        var orderPaymentTermsId = (_e = paymentTerms.orderPaymentTermsId) !== null && _e !== void 0 ? _e : undefined;
        if (paymentTermsTemplateId == null && rawId != null) {
            if (String(rawId).startsWith("gid://")) {
                paymentTermsTemplateId = String(rawId);
            }
            else if (!Number.isNaN(Number(rawId))) {
                orderPaymentTermsId = Number(rawId);
                var template = findTemplateByPaymentType(templates, paymentTermType, dueInDays);
                paymentTermsTemplateId = (_g = (_f = template === null || template === void 0 ? void 0 : template.id) !== null && _f !== void 0 ? _f : template === null || template === void 0 ? void 0 : template.Id) !== null && _g !== void 0 ? _g : null;
            }
            else {
                paymentTermsTemplateId = String(rawId);
            }
        }
        if (!paymentTermType && (dueInDays != null || dueDate != null)) {
            paymentTermType = dueInDays != null ? PaymentTermType.NET : dueDate != null ? PaymentTermType.FIXED : PaymentTermType.RECEIPT;
        }
        return {
            paymentTermType: paymentTermType,
            dueInDays: dueInDays,
            issueDate: issueDate,
            dueDate: dueDate,
            customDueDate: customDueDate !== null && customDueDate !== void 0 ? customDueDate : null,
            paymentTermsTemplateId: paymentTermsTemplateId,
            orderPaymentTermsId: orderPaymentTermsId,
        };
    }
    catch (_h) {
        return null;
    }
}
/** Default issue/custom due dates by term type. */
function applyDateDefaults(draftOrder, resolved) {
    var _a, _b, _c;
    try {
        var issueDate = resolved.issueDate, dueDate = resolved.dueDate, customDueDate = resolved.customDueDate, paymentTermType = resolved.paymentTermType;
        if (paymentTermType === PaymentTermType.NET && resolved.dueInDays != null && dueDate != null && issueDate == null) {
            issueDate = new Date(dueDate);
            issueDate.setDate(issueDate.getDate() - resolved.dueInDays);
        }
        else if (paymentTermType === PaymentTermType.FIXED && dueDate != null) {
            customDueDate = dueDate;
            if (issueDate == null) {
                var issueStr = (_c = (_b = (_a = draftOrder.note_attributes) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.name === "IssueDate"; })) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : null;
                issueDate = issueStr != null ? parseDateSafe(issueStr) : new Date();
                issueDate = issueDate !== null && issueDate !== void 0 ? issueDate : new Date();
            }
        }
        else if ((paymentTermType === PaymentTermType.RECEIPT || paymentTermType === PaymentTermType.FULFILLMENT) && issueDate == null) {
            issueDate = new Date();
        }
        return {
            issueDate: issueDate !== null && issueDate !== void 0 ? issueDate : new Date(),
            customDueDate: customDueDate !== null && customDueDate !== void 0 ? customDueDate : null,
        };
    }
    catch (_d) {
        return { issueDate: new Date(), customDueDate: null };
    }
}
/** Resolve payment terms from draft order for edit flow. Returns selector data or null. Accepts paymentTerms (Pascal) or payment_terms (snake). */
export function resolvePaymentTermsFromDraftOrder(draftOrderObj, paymentTermsTemplates) {
    var _a, _b, _c;
    if (paymentTermsTemplates === void 0) { paymentTermsTemplates = []; }
    try {
        if (!draftOrderObj)
            return null;
        var pt = (_a = draftOrderObj.paymentTerms) !== null && _a !== void 0 ? _a : draftOrderObj.payment_terms;
        if (!pt)
            return null;
        var templates = Array.isArray(paymentTermsTemplates) ? paymentTermsTemplates : [];
        var resolvedPaymentTerms = getPaymentTermsDataOfDraftOrder(pt, templates);
        if (!resolvedPaymentTerms || !resolvedPaymentTerms.paymentTermType)
            return null;
        var _d = applyDateDefaults(draftOrderObj, resolvedPaymentTerms), issueDate = _d.issueDate, customDueDate = _d.customDueDate;
        var result = {
            paymentTermType: resolvedPaymentTerms.paymentTermType,
            dueInDays: resolvedPaymentTerms.dueInDays,
            customDueDate: customDueDate !== null && customDueDate !== void 0 ? customDueDate : undefined,
            issueDate: issueDate,
            dueDate: (_b = resolvedPaymentTerms.dueDate) !== null && _b !== void 0 ? _b : undefined,
            paymentTermsTemplateId: (_c = resolvedPaymentTerms.paymentTermsTemplateId) !== null && _c !== void 0 ? _c : undefined,
        };
        return (resolvedPaymentTerms.orderPaymentTermsId != null ? __assign(__assign({}, result), { orderPaymentTermsId: resolvedPaymentTerms.orderPaymentTermsId }) : result);
    }
    catch (_e) {
        return null;
    }
}
/** Resolve payment terms for display (e.g. order details). Payment term type is normalized to uppercase. */
export function resolvePaymentTermsForDisplay(activeClientObj) {
    var _a, _b, _c;
    try {
        if (!(activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.paymentTerms))
            return null;
        var pt = activeClientObj.paymentTerms;
        var rawType = (_a = pt.paymentTermsType) !== null && _a !== void 0 ? _a : pt.paymentTermType;
        if (!rawType && pt.id == null && pt.name == null)
            return null;
        var paymentTermType = (normalizePaymentTermType(rawType) || PaymentTermType.RECEIPT);
        var dueInDays = parseDueInDaysFromApi(pt.dueInDays);
        var issueDate = (_b = parseDateSafe(pt.issueDate)) !== null && _b !== void 0 ? _b : new Date();
        var dueDate = (_c = parseDateSafe(pt.dueDate)) !== null && _c !== void 0 ? _c : undefined;
        return {
            paymentTermType: paymentTermType,
            dueInDays: dueInDays,
            paymentTermsTemplateId: pt.id != null ? String(pt.id) : undefined,
            issueDate: issueDate,
            dueDate: dueDate,
        };
    }
    catch (_d) {
        return null;
    }
}
/** @deprecated Use resolvePaymentTermsFromDraftOrder */
export var getPaymentTermsFromDraftOrder = resolvePaymentTermsFromDraftOrder;
/** @deprecated Use resolvePaymentTermsForDisplay */
export var getDisplayPaymentTerms = resolvePaymentTermsForDisplay;
